window.bm.ChapterPageViewModel = function (initialPageJson, subTopicAllTabLabel) {
  var self = this;

  self.Name = "ChapterPageViewModel";
  self.SubTopicAllTabLabel = subTopicAllTabLabel;
  self.CurrentSelectedTopicId = '';
  //Observables
  self.CurrentChapter = ko.observable(null);
  self.TopicTileSearchTerm = ko.observable('');
  self.CurrentSubTopicTabName = ko.observable(self.SubTopicAllTabLabel)

  //Computed Variables
  self.TopicGridTopics = ko.computed(function () {
    var topics = [];
    var tileCleanSearchTerm = '';
    if (!!self.TopicTileSearchTerm()) {
      tileCleanSearchTerm = self.TopicTileSearchTerm().trim().toLowerCase().replace(/[^A-zÀ-ÿ0-9 :&_,-]/g, "");
    }
    if (!!self.CurrentChapter()) {
      if (tileCleanSearchTerm.length > 2) {
        topics = ko.utils.arrayFilter(self.CurrentChapter().topics(), function (item) {
          return self.TopicTileFilterMatch(tileCleanSearchTerm, item);
        });
      } else {
        topics = self.CurrentChapter().topics();
      }
    }

    return topics
  });

  self.CurrentSelectedTopics = ko.computed(function () {
    if (!!self.CurrentChapter() && self.CurrentChapter().topics()) {
      return ko.utils.arrayFilter(self.CurrentChapter().topics(), function (item) {
        return item.Selected();
      });
    }

    return null;
  });

  self.Load = function (initialData) {
    if (!!initialData) {
      self.CurrentChapter(new Chapter(initialData));
    }
  };

  self.TopicTileFilterMatch = function (searchTerm, topicItem) {
    if (!!searchTerm) {
      var isMatch = true;
      var searchTermArr = searchTerm.split(/,| /);
      searchTermArr = $.grep(searchTermArr, function (n) { return (n); });

      var topicSearchNameArr = topicItem.topicTileSearchName.toLowerCase().split(/,|\|| /);
      topicSearchNameArr = $.grep(topicSearchNameArr, function (n) { return (n); });
      ko.utils.arrayForEach(searchTermArr, function (termItem) {
        var hasItem = ko.utils.arrayFirst(topicSearchNameArr, function (searchNameItem) {
          return searchNameItem.indexOf(termItem) === 0;
        });

        if (hasItem == null) {
          isMatch = false;
        }
      });

      return isMatch;
    } else {
      return true;
    }
  }

  self.Load(initialPageJson)
};

ko.bindingHandlers.BindTopicTileContentTrigger = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var topicItem = valueAccessor();
    if (!!topicItem && !!bindingContext.$root.ChapterPageViewModel.CurrentChapter()) {
      $(element).click(function (ev) {
        ev.preventDefault();

        var $this = $(this);
        if (topicItem.Selected()) {
          var scrollPosition = Math.ceil($('.topic-help').offset().top + $('.topic-help').outerHeight());
          var qs = "?scroll=" + scrollPosition;
          History.pushState({ qs: qs }, History.options.initialTitle, qs);
        } else {
          var scrollPosition = Math.ceil($('.topic-grid').offset().top + $('.topic-grid').outerHeight()) - 30;
          bindingContext.$root.ChapterPageViewModel.CurrentSelectedTopicId = topicItem.id;
          var qs = "?topic=" + topicItem.id + "&scroll=" + scrollPosition;
          History.pushState({ qs: qs }, History.options.initialTitle, qs);
        }
      });
    }
  }
};

ko.bindingHandlers.BindSubTopicTabChange = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var entity = valueAccessor();
    var tabId = $(element).data('tabid');
    if (!!tabId && tabId.length > 0) {
      $(element).click(function (ev) {
        ev.preventDefault();
        var qs = "?topic=" + bindingContext.$root.ChapterPageViewModel.CurrentSelectedTopicId + "&subtopic=" + tabId + "&scroll=" + $(window).scrollTop();
        History.pushState({ qs: qs }, History.options.initialTitle, qs);
      });
    }
  }
};
ko.bindingHandlers.BindTopicTileHover = {

  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    $(element).on('mouseenter', function () {
      var currentHeight = $(this).parent().height();
      $(this).addClass('tile-hovered');
      $(this).parent().css('height', currentHeight + 'px');

    });
    $(element).on('mouseleave', function () {
      $(this).parent().css('height', 'auto');
      $(this).removeClass('tile-hovered');
    });
  }
};
ko.bindingHandlers.QuestionAccordionTrigger = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var question = valueAccessor();

    $(element).click(function (ev) {
      ev.preventDefault();
      var scrollPosition = bindingContext.$root.SetAccordionExpandCollapse($(this).parent());
      $("html, body").animate({ scrollTop: scrollPosition }, "slow");
    });
  }
};